














































































































































































































import BaseComponent from '@/core/base.component';
import { Component } from 'vue-property-decorator';
import { PickcookPopupDto } from '@/dto';
import PickcookPopupService from '@/services/pickcook/pickcook-popup.service';
import {
  FileAttachmentDto,
  PICKCOOK_UPLOAD_TYPE,
} from '@/services/shared/file-upload';
import PickcookFileUploadService from '../../../../services/shared/file-upload/pickcook-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import { CONST_YN, Pagination, YN } from '@/common';
import { PickcookCodeManagementDto } from '@/services/init/dto';
import CommonCodeService from '@/services/pickcook/common-code.service';
import { EditorConfig } from '@/config';
import { VueEditor } from 'vue2-editor';
import toast from '../../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'PickcookPopupDetail',
  components: {
    VueEditor,
  },
})
export default class PickcookPopupDetail extends BaseComponent {
  private popupDto = new PickcookPopupDto();
  private popupUpdateDto = new PickcookPopupDto();

  private showYn: YN[] = [...CONST_YN];
  private popupTypeSelect: PickcookCodeManagementDto[] = [];
  private linkTypeSelect: PickcookCodeManagementDto[] = [];
  private imageChanged = false;
  private newPopupImage: FileAttachmentDto[] = [];
  private newPopupMobileImage: FileAttachmentDto[] = [];

  private editorToolbar = EditorConfig;
  private codeManagementDto = new PickcookCodeManagementDto();
  private paginationCode = new Pagination();

  getLinkUrl(linkUrl: string) {
    if (linkUrl) {
      return linkUrl.includes('//') ? linkUrl : `//${linkUrl}`;
    }
  }

  getTypeCodes() {
    this.codeManagementDto.category = 'POPUP';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.popupTypeSelect = res.data.items;
    });

    this.codeManagementDto.category = 'LINK_TYPE';
    CommonCodeService.findAll(
      this.codeManagementDto,
      this.paginationCode,
    ).subscribe(res => {
      this.linkTypeSelect = res.data.items;
    });
  }

  findOne(id) {
    PickcookPopupService.findOne(id).subscribe(res => {
      if (res) {
        this.popupDto = res.data;
        this.popupUpdateDto = this.popupDto;
        this.popupUpdateDto.started = new Date(this.popupDto.started);
        this.popupUpdateDto.ended = new Date(this.popupDto.ended);
      }
    });
  }

  // upload popup image
  async uploadPopup(file: File) {
    if (file) {
      const attachments = await PickcookFileUploadService.upload(
        PICKCOOK_UPLOAD_TYPE.POPUP,
        [file],
      );
      this.newPopupImage = [];
      this.newPopupImage.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.imageChanged = true;
    }
  }

  removePopupImage() {
    this.newPopupImage = [];
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  updatePopup() {
    if (this.newPopupImage.length > 0) {
      this.popupUpdateDto.images = this.newPopupImage;
    } else {
      delete this.popupUpdateDto.images;
    }
    const startedDate = new Date(this.popupUpdateDto.started);
    const endedDate = new Date(this.popupUpdateDto.ended);
    this.popupUpdateDto.started = new Date(
      startedDate.getFullYear(),
      startedDate.getMonth(),
      startedDate.getDate(),
      0,
      0,
      0,
    );
    this.popupUpdateDto.ended = new Date(
      endedDate.getFullYear(),
      endedDate.getMonth(),
      endedDate.getDate(),
      23,
      59,
      59,
    );

    PickcookPopupService.update(
      this.$route.params.id,
      this.popupUpdateDto,
    ).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne(this.$route.params.id);
      }
    });
  }

  deleteOne() {
    PickcookPopupService.deleteOne(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('삭제완료');
        this.$router.push('/pickcook/popup');
      }
    });
  }

  created() {
    this.findOne(this.$route.params.id);
    this.getTypeCodes();
  }
}
